import { getCLS, getFID, getFCP, getLCP, getTTFB } from 'web-vitals';
import { inject } from '@vercel/analytics';

inject();
